import styled from "styled-components";
import React from "react";

export const Header = styled.header`
    height: 4.5rem;
    width: 100%;
    background: white;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);

    span {
        font-size: 1.5rem;
        font-weight: 600;
        line-height: 2rem;
    }

    strong {
        font-size: 1.5rem;
        line-height: 2rem;
        color: ${({ theme }) => theme.color.primary.background};
    }

    .content {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .logo-content{
            text-align: right;

        img {
            width: 100%;
            max-height: 5rem;
            object-fit: contain;
            aspect-ratio: 4/3;

        }
    }



`;


type PoweredByHeaderProps = {
    organizationLogo?: string
}

export const PoweredByHeader = ({organizationLogo}:PoweredByHeaderProps) => {
    return (
        <Header>
            <div className="container">
                <div className="content">
                    <div >
                        <span>Powered by </span>
                        <strong>FOTOP</strong>
                    </div>
                    {
                        organizationLogo && (
                            <div className="logo-content">
                                <img src={organizationLogo} alt="logo do cliente logado" />
                            </div>
                        )
                    }
                </div>
            </div>
        </Header>
    );
};
